module.exports = __webpack_public_path__ + "assets/img/d28770100bddbeaf8dbf359adbd3939a.png";